export enum FeedbackOnFeedbackActionType {
  SET_RECORD_IN_EDIT_MODE = 'SET_RECORD_IN_EDIT_MODE',
  RESET_RECORD_IN_EDIT_MODE = 'RESET_RECORD_IN_EDIT_MODE',
  SET_SHOULD_REFETCH = 'SET_SHOULD_REFETCH',
  SET_EDITED_RECORDS = 'SET_EDITED_RECORDS',
  SET_HAS_PREDICTION_FADED_IN = 'SET_HAS_PREDICTION_FADED_IN',
  SET_FLAG_ON_RECORD_SUMMARY = 'SET_FLAG_ON_RECORD_SUMMARY',
  REMOVE_FLAG_FROM_RECORD_SUMMARY = 'REMOVE_FLAG_FROM_RECORD_SUMMARY',
}
